<template>
    <b-card title="Invoices Submitted to Carrier for Reimbursement">

      <loading-card v-if="loading" :message="this.loading_message" />

      <b-table hover
                 sort-by="created_at"
                :items="items"
                :fields="fields">
            <template v-slot:cell(actions)="data">
              <div v-if="data.item.pdf">
                <b-button variant="secondary" @click="downloadSaved(data.item, 'pdf')">View PDF</b-button>
              </div>
              <div v-else>
                <a :href="`/invoice-history/${data.item.id}/print`" class="btn btn-secondary">
                  View PDF
                </a>
              </div>
            </template>
        </b-table>
    </b-card>
</template>

<script>
    import FormatsDates from '../../mixins/FormatsDates';
    import FormatsNumbers from '../../mixins/FormatsNumbers';
    import DownloadsFiles from '../../mixins/DownloadsFiles'

    export default {
        props: ['client', 'invoices'],

        mixins: [FormatsDates, FormatsNumbers, DownloadsFiles],

        data() {
            return {
              default_loading_message : 'Loading...',
              loading_message : '',
              loading: false,
                items: this.invoices,
                fields: [
                    {
                        key: 'name',
                        label: 'Invoice #',
                    },
                    // {
                    //     key: 'week',
                    //     label: 'Week Ending',
                    //     formatter: this.weekEnding,
                    // },
                    {
                        key: 'submitted_at',
                        label: 'Date Submitted',
                        formatter: (val) => val ? this.formatDateFromUTC(val) : 'Pending',
                    },
                    {
                        key: 'hours',
                        formatter: (val) => this.numberFormat(val),
                    },
                    {
                        key: 'amount',
                        formatter: (val) => this.moneyFormat(val),
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ]
            }
        },
        methods: {
            weekEnding(week) {
                if (week) {
                    if ('end' in week) {
                        return this.formatDate(week.end);
                    }
                }
                return 'N/A';
            },
          downloadSaved(item, format = 'pdf') {
            const url = `/generated-invoices/${item.id}`;
            const data = {
              url,
              method: 'POST',
              data: {
                format,
              }
            }
            this.loading_message = 'Downloading File...';
            this.loading = true;
            this.downloadFile(data).finally(() => {
              this.loading = false;
              this.loading_message = this.default_loading_message;
            })
          }
        }
    }
</script>
